import React from "react";
import { Row, Col, Descriptions, Card } from "antd";
import { VehicleTypeMap } from "@/utils/enum";
import { formatDistance } from "@/utils/utils";
import { DrivabilityTag } from "@/components/Tags";
const VehiclePricingInfo = ({ shipmentData, vehicleData }) => {
    if (!shipmentData || !vehicleData)
        return null;
    const { distance, pickupAddress, dropOffAddress } = shipmentData;
    const { year, make, model, vin, vehicleType, drivabilityType, curbWeight, exteriorDimensions } = vehicleData;
    return (React.createElement(Row, { gutter: [0, 16] },
        React.createElement(Col, { span: 24 },
            React.createElement(Card, { title: "Vehicle Information", size: "small", className: "noLeftMarginCard" },
                React.createElement(Descriptions, { size: "small", column: { xs: 1, sm: 2, md: 3 }, style: { marginBottom: 0 } },
                    React.createElement(Descriptions.Item, { label: "Year" }, year),
                    React.createElement(Descriptions.Item, { label: "Make" }, make),
                    React.createElement(Descriptions.Item, { label: "Model" }, model),
                    React.createElement(Descriptions.Item, { label: "VIN" }, vin),
                    React.createElement(Descriptions.Item, { label: "Type" }, VehicleTypeMap[vehicleType]),
                    React.createElement(Descriptions.Item, { label: "Status" },
                        React.createElement(DrivabilityTag, { drivabilityType: drivabilityType })),
                    React.createElement(Descriptions.Item, { label: "Curb Weight" }, curbWeight),
                    React.createElement(Descriptions.Item, { label: "Exterior Dimensions" }, exteriorDimensions)))),
        React.createElement(Col, { span: 24 },
            React.createElement(Card, { title: "Shipment Information", size: "small", className: "noLeftMarginCard" },
                React.createElement(Descriptions, { size: "small", column: 1, style: { marginBottom: 0 } },
                    React.createElement(Descriptions.Item, { label: "Pickup Address" }, pickupAddress?.completedAddress),
                    React.createElement(Descriptions.Item, { label: "Dropoff Address" }, dropOffAddress?.completedAddress),
                    React.createElement(Descriptions.Item, { label: "Distance" },
                        formatDistance(distance),
                        " miles"))))));
};
export default VehiclePricingInfo;
